const SECOND = 1000;
function processMapInBatches(map, batchSize, processBatchCallback, 
// reports the pending inter-batch timeout so the caller can cancel it on stop()
onScheduled, 
// called once the whole map has been walked (or there was nothing to walk)
onComplete) {
    const iterator = map.entries();
    function processNextBatch() {
        let processed = 0;
        let result = iterator.next();
        // process inline as we pull from the iterator — no intermediate array.
        // deleting from the map during iteration (via unregisterNode) is safe:
        // unvisited deleted entries are skipped, newly added nodes get visited.
        while (!result.done && processed < batchSize) {
            const node = result.value[1];
            if (node) {
                processBatchCallback(node);
            }
            processed++;
            result = iterator.next();
        }
        if (processed > 0) {
            // yield the thread between batches so the browser can run other work
            onScheduled(setTimeout(processNextBatch, 50));
        }
        else {
            onComplete();
        }
    }
    processNextBatch();
}
function isNodeStillActive(node) {
    try {
        if (!node.isConnected) {
            return [false, 'not connected'];
        }
        const nodeIsDocument = node.nodeType === Node.DOCUMENT_NODE;
        const nodeWindow = nodeIsDocument
            ? node.defaultView
            : node.ownerDocument?.defaultView;
        const ownerDoc = nodeIsDocument ? node : node.ownerDocument;
        if (!nodeWindow) {
            return [false, 'no window'];
        }
        if (nodeWindow.closed) {
            return [false, 'window closed'];
        }
        if (!ownerDoc?.documentElement.isConnected) {
            return [false, 'documentElement not connected'];
        }
        return [true, 'ok'];
    }
    catch (e) {
        return [false, e];
    }
}
const defaults = {
    interval: SECOND * 30,
    batchSize: 2500,
    enabled: true,
};
class Maintainer {
    constructor(nodes, unregisterNode, options) {
        this.nodes = nodes;
        this.unregisterNode = unregisterNode;
        this.isScanning = false;
        this.start = () => {
            if (!this.options.enabled) {
                return;
            }
            this.stop();
            this.interval = setInterval(() => {
                // a previous scan may still be walking the map across batch timeouts
                // (large DOM and/or background-tab timer throttling). don't pile up.
                if (this.isScanning) {
                    return;
                }
                this.isScanning = true;
                processMapInBatches(this.nodes, this.options.batchSize, (node) => {
                    const isActive = isNodeStillActive(node)[0];
                    if (!isActive) {
                        this.unregisterNode(node);
                    }
                }, (timeout) => {
                    this.batchTimeout = timeout;
                }, () => {
                    this.batchTimeout = undefined;
                    this.isScanning = false;
                });
            }, this.options.interval);
        };
        this.stop = () => {
            if (this.interval) {
                clearInterval(this.interval);
            }
            if (this.batchTimeout) {
                clearTimeout(this.batchTimeout);
                this.batchTimeout = undefined;
            }
            this.isScanning = false;
        };
        this.options = { ...defaults, ...options };
    }
}
export default Maintainer;
